function shortCurrency($filter, Helper) {
  'ngInject';
  return function(number, currency, fractionSize, shortAbove) {

    number = number || 0;
    currency = currency || '$';
    fractionSize = fractionSize || 0;

    var output = Helper.shortNumber(number, shortAbove);

    return $filter('currency')(output[0], currency, fractionSize) + output[1];

  };
}
export { shortCurrency };
